import React from 'react';
import { Shield, Globe, Award, Truck } from 'lucide-react';
import { motion } from 'framer-motion';
import { scaleIn, revealOnce } from '@/lib/motion';

const BADGES = [
  { icon: Shield, label: 'Quality Assured', sub: 'FSSAI Certified', color: '#D4870A' },
  { icon: Globe, label: 'Global Reach', sub: '15+ Countries', color: '#6B8E23' },
  { icon: Award, label: 'Export Experience', sub: '10+ Years', color: '#C0392B' },
  { icon: Truck, label: 'Delivery Guaranteed', sub: 'On-Time', color: '#8B7355' },
];

export default function StatBadges() {
  return (
    <section className="py-8 px-4 sm:px-6 lg:px-8 bg-white border-b border-saffron-100/50" data-testid="stat-badges">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-2 sm:grid-cols-4 gap-4">
          {BADGES.map((item, i) => (
            <motion.div
              key={item.label}
              {...revealOnce}
              variants={scaleIn} transition={{ delay: i * 0.1 }}
              className="flex items-center gap-3 p-4 rounded-lg bg-cream/50 border border-saffron-100/30"
              data-testid={`stat-badge-${i}`}
            >
              <div className="w-10 h-10 rounded-lg flex items-center justify-center flex-shrink-0" style={{ backgroundColor: item.color + '12' }}>
                <item.icon size={18} style={{ color: item.color }} />
              </div>
              <div>
                <p className="font-display text-sm font-bold text-earth-dark">{item.label}</p>
                <p className="text-[10px] text-earth/50 font-sans">{item.sub}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
